import React from 'react';
import { Link } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { Headphones } from 'lucide-react';

const MinimalFooter: React.FC = () => {
  return (
    <footer className="py-6 border-t border-border">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <Link to="/" className="flex items-center gap-2 mb-4 md:mb-0">
            <img src="/logo.svg" alt="BinauralFlow" className="h-10 w-10" />
            <span className="font-semibold">BinauralFlow</span>
          </Link>
          
          <div className="flex items-center gap-4">
            <p className="text-sm text-muted-foreground flex items-center gap-2">
              <Headphones className="h-4 w-4" />
              For optimal experience, use headphones or earbuds
            </p>
            <Dialog>
              <DialogTrigger asChild>
                <button className="text-sm text-muted-foreground hover:text-foreground hover:underline transition-colors">
                  Legal
                </button>
              </DialogTrigger>
              <DialogContent className="sm:max-w-[425px]">
                <DialogHeader>
                  <DialogTitle>Legal Information</DialogTitle>
                </DialogHeader>
                <div className="space-y-4 py-4">
                  <div className="text-sm text-muted-foreground">
                    <p className="mb-2">© 2025 BinauralFlow by UpwardBit Ventures LLC. All rights reserved.</p>
                    <div className="space-y-2">
                      <p>
                        <a 
                          href="https://binauralflow.ai/privacy-policy" 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="text-primary hover:underline"
                        >
                          Privacy Policy
                        </a>
                      </p>
                      <p>
                        <a 
                          href="https://binauralflow.ai/terms-conditions" 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="text-primary hover:underline"
                        >
                          Terms & Conditions
                        </a>
                      </p>
                      <p>
                        <a 
                          href="https://binauralflow.ai/cookie-policy" 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="text-primary hover:underline"
                        >
                          Cookie Policy
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </DialogContent>
            </Dialog>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default MinimalFooter; 